/**
 * TenantOption :
 * Représentation UI d'un tenant (id + label affiché).
 * Utilisé dans les selects / header / navigation.
 */
export type TenantOption = {
  id: string;
  name: string;
};

export const TENANT_STATUS = {
  INITIALIZING: "initializing",
  VALIDATING: "validating",
  READY: "ready",
  SWITCHING: "switching",
} as const;

/**
 * Type représentant le statut du tenant.
 * - INITIALIZING: pas encore de tenant courant résolu (ex: au boot)
 * - VALIDATING: validation tenantService en cours
 * - READY: tenant courant prêt
 * - SWITCHING: changement de tenant (overlay UX)
 */
export type TenantStatus = (typeof TENANT_STATUS)[keyof typeof TENANT_STATUS];

export type TenantRouteParams = {
  tenantId?: string;
};

/**
 * Type représentant le tenant renvoyé par l'API.
 * - tenantId: ID du tenant.
 * - tenantName: Nom du tenant.
 */
export type TenantApiDto = {
  tenantId: string;
  tenantName: string;
};
